import {
  ListLoader,
  ListOptionsProps,
  ListOptionsWrapper,
  getEmptyValue,
  getPanelHeight,
  renderOption,
} from '@systemeio/ui'
import { Fragment, useState } from 'react'
import { FormSelectDataWithGroupType } from 'shared/components/form-select/form-select-with-groups'
import { twMerge } from 'tailwind-merge'

export interface ListOptionsWithGroupsProps extends Omit<ListOptionsProps, 'data'> {
  groups: { id: string; caption: string }[]
  data: FormSelectDataWithGroupType[] | undefined
}

export function ListOptionsWithGroups({
  optionsClassName,
  data,
  loaderWrapperClassName,
  loaderClassName,
  groups,
  asOptions,
  asOption,
  ...optionProps
}: ListOptionsWithGroupsProps) {
  const dataByGroup = (data ?? []).reduce((acc, item) => {
    return {
      ...acc,
      [item.group]: acc[item.group] ? [...acc[item.group], item] : [item],
    }
  }, {} as Record<string, FormSelectDataWithGroupType[]>)

  const mapData = Object.entries(dataByGroup)

  const [listRef, setListRef] = useState<HTMLElement | null>(null)

  const height = getPanelHeight(listRef, data)

  return (
    <ListOptionsWrapper
      ref={setListRef}
      style={{ height }}
      as={asOptions}
      optionsClassName={twMerge('h-fit', optionsClassName)}
    >
      {data === undefined ? (
        <ListLoader
          loaderWrapperClassName={loaderWrapperClassName}
          loaderClassName={loaderClassName}
        />
      ) : (
        <>
          {mapData.length > 0
            ? mapData.map(([key, value]) => {
                const groupCaption = groups.find(group => group.id === key)?.caption
                return (
                  <Fragment key={key}>
                    <div
                      role="option"
                      className={
                        'text-text-primary border-text-secondary/30 w-full border-b px-4 py-1.5 font-bold'
                      }
                    >
                      {groupCaption}
                    </div>
                    {value.map(item => renderOption({ item, as: asOption, ...optionProps }))}
                  </Fragment>
                )
              })
            : renderOption({ item: getEmptyValue(), as: asOption, ...optionProps })}
        </>
      )}
    </ListOptionsWrapper>
  )
}
